'use client';

import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import ContactButton from 'components/About/ContactButton';
import ChatWithUsDiscordButton from 'components/About/ChatWithUsDiscordButton';
import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
import { HELP_CENTER_FEEDBACK } from 'helpers/graphql/helpCenter';

const reactions = [
  {
    emoji: '😞',
    label: 'Not helpful',
  },
  {
    emoji: '😐',
    label: 'Somewhat helpful',
  },
  {
    emoji: '😀',
    label: 'Very helpful',
  },
];

export default function Feedback() {
  const router = useRouter();
  const { slug } = router.query;

  const [reaction, setReaction] = useState(null);

  const [helpCenterFeedback] = useMutation(HELP_CENTER_FEEDBACK);

  useEffect(() => {
    const reaction = Cookies.get(`feedback-help-${slug}`);
    setReaction(reaction);
  }, [slug, reaction]);

  const { enqueueSnackbar } = useSnackbar();

  return (
    <div className="tw-mb-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-2 tw-border-t tw-border-gray-200 tw-py-10">
      <p className="tw-text-gray-500 sm:tw-text-lg">
        Did this answer your question?
      </p>
      <div className="tw-flex tw-space-x-4">
        {reactions.map(({ emoji, label }) => (
          <button
            key={label}
            onClick={() => {
              Cookies.set(`feedback-help-${slug}`, label);
              setReaction(label);
              enqueueSnackbar(`Feedback recorded – thank you!`, {
                variant: 'success',
              });
              helpCenterFeedback({
                variables: {
                  slug,
                  rating:
                    label === 'Not helpful'
                      ? 'notHelpful'
                      : label === 'Somewhat helpful'
                      ? 'somewhatHelpful'
                      : 'veryHelpful',
                },
              }).catch(err => console.log(err));
            }}
            className={
              'twbtn tw-text-4xl tw-transition-all tw-duration-75 hover:tw-scale-110 active:tw-scale-100' +
              (reaction && reaction !== label
                ? ' tw-scale-90 tw-grayscale'
                : reaction === label
                ? ' tw-scale-110'
                : '')
            }
          >
            {emoji}
          </button>
        ))}
      </div>
      {(reaction === 'Not helpful' || reaction === 'Somewhat helpful') && (
        <>
          <div className="tw-flex">
            <ContactButton />
            <ChatWithUsDiscordButton />
          </div>
        </>
      )}
    </div>
  );
}
